export default "/_next/static/images/ad3-afd6768e313b70230554c6ac125dfa60.png";